export const CLEAR_ACCOUNT_SEARCH = 'CLEAR_ACCOUNT_SEARCH';
export const SET_ACCOUNTS = 'SET_ACCOUNTS';
export const SET_SELECTED_ACCOUNT = 'SET_SELECTED_ACCOUNT';
export const SET_SELECTED_PURCHASE = 'SET_SELECTED_PURCHASE';
export const SET_ACCOUNT_REINSTATE_INFO = 'SET_SELECTED_REINSTATE_INFO';

export const ACCOUNT_STATUS = {
  IN_DETENTION: 'IN_DETENTION',
  NOT_IN_DETENTION: 'NOT_IN_DETENTION',
  CANNOT_BE_REINSTATED: 'CANNOT_BE_REINSTATED',
};

// SPD-7468: Chegg to append extended url to to 'chegg.com'
export const ACCOUNT_STATUS_TEXT_EXTENDED_URL = '/study/qa/post';

export const GLADLY_ACCOUNT_STATUS = {
  IN_DETENTION: 'User is in Detention.',
  SUSPENSION_IN_DETENTION: 'Suspension: User is in detention',
  NOT_IN_DETENTION: 'User is not in Detention.',
  CANNOT_BE_REINSTATED: 'User is not eligible to be reinstated.',
  FORCED_PASSWORD_RESET: 'Forced PW Reset: User must reset their password on chegg.com/study/qa/post',
  SUSPENSION_FORCED_PASSWORD_RESET:
    'Suspension & Forced PW Reset: User is suspended, and must also reset their password on chegg.com/study/qa/post',
  FORCED_PASSWORD_RESET_BASE_URL: 'Forced PW Reset: User must reset their password on chegg.com',
  SUSPENSION_FORCED_PASSWORD_RESET_BASE_URL:
    'Suspension & Forced PW Reset: User is suspended, and must also reset their password on chegg.com',
};
